module.exports = __webpack_public_path__ + "static/80330366_434938574079473_4857682439264272384_n_optimized-167f5c53a089841e68b4c3e59e42445a.jpg";